export default "__VITE_ASSET__793589da__"